import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs } from 'antd';
import VerificationCode from '../../../Login/VerificationCode';
import Password from '../../../Login/Password';
import ForgetPassword from '../../../Login/ForgetPassword';
import s from '../../../Login/style.m.less';
import InformationModal from '../InformationModal';
import withRouter from '@/components/withRouter';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
import style from './style.m.less';
@inject('store')
@observer
class Qhb extends Component {
    state = {
        loading: true
    };
    async componentDidMount() {
        const {
            store: { login }
        } = this.props,
         competition_id = this.props.params?.id || '';
        login.setQhbMode('region');
        login.setQegionId(competition_id);
        // 2025年启航杯登录后跳转到2025年专题页 /2025/region_qhb_tenant/:id
        login.setRedirectUrl(`https://${window.location.host}/web/2025/region_qhb_tenant/${competition_id}`);
        const isLogin = await login.checkLogin();
        if (isLogin) {
            return login.loginCallback(null,'competition');
        }
        this.setState({
            loading: false
        });
    }
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };

    render() {
        const {
            store: { login }
        } = this.props;

        return this.state.loading ?
        <GrtLoading /> :
        <div className={`${s.competition_app} ${s.region_app}`}>
            <div style={{ height: 'calc(100vh - 50px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '1200px' }}>
                    <div className={style.region_logo}></div>

                    <div className={s.right}>
                        <div style={{ minWidth: '200px', height: '22px' }}></div>
                    </div>

                    <div className={s.region_text}></div>
                    <div className={s.competition_content}>
                        <Card hoverable>
                            {login.mode === 'login' ? (
                                <Tabs
                                    onChange={this.onChange}
                                    activeKey={login.activeKey}
                                    items={[
                                        {
                                            key: 'code',
                                            label: '验证码登录',
                                            children: <VerificationCode type="competition" />
                                        },
                                        {
                                            key: 'password',
                                            label: '密码登录',
                                            children: <Password type="competition" />
                                        }
                                    ]}
                                />
                            ) : (
                                <ForgetPassword type="competition" />
                            )}
                        </Card>
                    </div>
                </div>
            </div>
            <div className={s.footer} style={{ height: '50px' }}>
                <div
                    style={{
                        width: '1200px',
                        height: '50px',
                        margin: '0 auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <div className={s.footer_text}>
                        <div>技术支持：北京国人通教育科技有限公司</div>
                    </div>
                </div>
            </div>
            <InformationModal />
        </div>;
    }
}

export default withRouter(Qhb);
